<section id="inicio" class="hero">
  <div class="hero-content">
      <h1>Don Chon</h1>
      <h2>Auténtica Cocina China</h2>
      <p>Una experiencia gastronómica única con los mejores sabores de la tradición oriental</p>
      <p-button label="Ver la Carta" [rounded]="true" severity="danger" size="large" />
  </div>
</section>